// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contenedor-details-horizontal {
    display: flex;
    flex-wrap: wrap; /* Permite que los elementos se envuelvan a la siguiente línea si no hay espacio */
    justify-content: flex-start; /* Alinea los elementos al inicio del contenedor */
    gap: 15px; /* Espacio entre los elementos */
    padding: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 5px;
    margin-bottom: 20px;
}

.contenedor-info {
    flex: 1 1 auto; /* Permite que los elementos crezcan y se encojan, ocupando el espacio disponible */
    min-width: 180px; /* Ancho mínimo para cada elemento de información */
    text-align: left;
}

.tipos-mercancia-container {
    display: flex;
    align-items: center; /* Alinea verticalmente el texto y la lista */
    gap: 10px; /* Espacio entre el título y la lista */
}

.tipos-mcia-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start; /* Alinea los elementos de la lista a la izquierda */
    gap: 5px;
}

.tipos-mcia-list li {
    white-space: nowrap; /* Evita que los elementos de la lista se rompan en varias líneas */
}

.tipos-mcia-list li {
    background-color: #f0f0f0;
    padding: 3px 8px;
    border-radius: 3px;
    font-size: 0.9em;
}`, "",{"version":3,"sources":["webpack://./src/styles/TotalesEncabezadoHistoricoContenedor.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe,EAAE,kFAAkF;IACnG,2BAA2B,EAAE,kDAAkD;IAC/E,SAAS,EAAE,gCAAgC;IAC3C,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc,EAAE,mFAAmF;IACnG,gBAAgB,EAAE,mDAAmD;IACrE,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB,EAAE,6CAA6C;IAClE,SAAS,EAAE,uCAAuC;AACtD;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,aAAa;IACb,eAAe;IACf,2BAA2B,EAAE,oDAAoD;IACjF,QAAQ;AACZ;;AAEA;IACI,mBAAmB,EAAE,mEAAmE;AAC5F;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB","sourcesContent":[".contenedor-details-horizontal {\n    display: flex;\n    flex-wrap: wrap; /* Permite que los elementos se envuelvan a la siguiente línea si no hay espacio */\n    justify-content: flex-start; /* Alinea los elementos al inicio del contenedor */\n    gap: 15px; /* Espacio entre los elementos */\n    padding: 10px;\n    border: 1px solid #e0e0e0;\n    border-radius: 5px;\n    margin-bottom: 20px;\n}\n\n.contenedor-info {\n    flex: 1 1 auto; /* Permite que los elementos crezcan y se encojan, ocupando el espacio disponible */\n    min-width: 180px; /* Ancho mínimo para cada elemento de información */\n    text-align: left;\n}\n\n.tipos-mercancia-container {\n    display: flex;\n    align-items: center; /* Alinea verticalmente el texto y la lista */\n    gap: 10px; /* Espacio entre el título y la lista */\n}\n\n.tipos-mcia-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start; /* Alinea los elementos de la lista a la izquierda */\n    gap: 5px;\n}\n\n.tipos-mcia-list li {\n    white-space: nowrap; /* Evita que los elementos de la lista se rompan en varias líneas */\n}\n\n.tipos-mcia-list li {\n    background-color: #f0f0f0;\n    padding: 3px 8px;\n    border-radius: 3px;\n    font-size: 0.9em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
